// extracted by mini-css-extract-plugin
export default {"subNav":"index_subNav_lZ-WT clearfix","label":"index_label_HWbXL","link":"index_link_3y1bt"};